import axios from "axios";
import React, { useState } from "react";
import SecurityHeaders from "../../context/SecurityHeaders";
import { Link, useNavigate } from "react-router-dom";
import { AccountCircle } from "@material-ui/icons";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import ENDPOINT from "../../context/EndPoint";

const AddCompany = ({ }) => {
    const dispatch = useDispatch()
    const [companyName, setCompanyName] = useState("");
    const [website, setWebsite] = useState("");
    const [companyRegisteredName, setCompanyRegisteredName] = useState("");
    const [companyLocation, setCompanyLocation] = useState("");
    const [city, setCity] = useState("");
    const [companyAdminName, setCompanyAdminName] = useState("");
    const [companyAdminEmail, setCompanyAdminEmail] = useState("");
    const [companyAdminPhone, setCompanyAdminPhone] = useState("");
    const [companyRegistered, setCompanyRegistered] = useState("");
    const [companyDescription, setCompanyDescription] = useState("");
    const [companyLogo, setCompanyLogo] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const navigate = useNavigate();

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith("image/")) {
            setCompanyLogo(file);
        } else {
            setMessage("Please upload a valid image file.");
        }
    };

    const addCompany = async (e) => {
        dispatch({type:'LOADING'})
        e.preventDefault();
        setLoading(true);
        setMessage("");

        const data = new FormData();
       if( companyLogo&& companyLogo.type.startsWith('image/')){
         data.append("company_logo", companyLogo);
       }
        data.append("company_name", companyName.trim());
        data.append("website", website.trim());
        data.append("company_registered_name", companyRegisteredName.trim());
        data.append("company_location", companyLocation.trim());
        data.append("city", city.trim());
        data.append("company_admin_name", companyAdminName.trim());
        data.append("company_admin_email", companyAdminEmail.trim());
        data.append("company_admin_phone", companyAdminPhone.trim());
        data.append("company_registered", companyRegistered.trim());
        data.append("company_description", companyDescription.trim());

        try {
            const res = await axios.post(ENDPOINT+
                "add-company.php",
                data,
                SecurityHeaders
            );

            if (res.data.status === "success") {
                dispatch({type:'DONE_LOADING'})
                setMessage("Company added successfully!");

                navigate("/company")
            } else {
                dispatch({type:'ERROR',payload:'Error adding company'})
                setMessage(res.data.message || "Error adding company.");
            }
        } catch (error) {
            dispatch({type:'ERROR',payload: error.message})

            setMessage("An error occurred while adding the company.");
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="d-flex justify-content-center">
            <div className="container card col-11 col-lg-10 col-sm-12 col-md-10 p-4 shadow rounded-3">
                <h2 className="text-center mb-2">Add Company</h2>
                {message && (
                    <div
                        className={`alert ${message.includes("success") ? "alert-success" : "alert-danger"}`}
                        role="alert"
                    >
                        {message}
                    </div>
                )}
                <form onSubmit={addCompany}>
                    {/* File Upload */}
                    <div className="mb-3">
                        <label className="form-label">Company Logo</label>
                        <div
                            style={{
                                height: 90,
                                width: 90,
                                borderRadius: "50%",
                                overflow: "hidden",
                                cursor: "pointer",
                                backgroundColor: "#f0f0f0",
                                backgroundImage: companyLogo
                                    ? `url(${URL.createObjectURL(companyLogo)})`
                                    : "none",
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                            }}
                            onClick={() => document.getElementById("fileInput").click()}
                        >
                            {!companyLogo && (
                                <AccountCircle style={{ height: "100%", width: "100%", color: "#ccc" }} />
                            )}
                        </div>
                        <input
                            type="file"
                            id="fileInput"
                            style={{ display: "none" }}
                            accept="image/*"
                            onChange={handleFileChange}
                        />
                    </div>

                    {/* Company Name */}
                    <div className="mb-3">
                        <label className="form-label">Company Name</label>
                        <input
                            type="text"
                            className="form-control"
                            value={companyName}
                            onChange={(e) => setCompanyName(e.target.value)}
                            required
                        />
                    </div>

                    {/* Website */}
                    <div className="mb-3">
                        <label className="form-label">Website</label>
                        <input
                            type="text"
                            className="form-control"
                            value={website}
                            onChange={(e) => setWebsite(e.target.value)}
                        />
                    </div>

                    {/* Company Registered Name */}
                    <div className="mb-3">
                        <label className="form-label">Registered Name</label>
                        <input
                            type="text"
                            className="form-control"
                            value={companyRegisteredName}
                            onChange={(e) => setCompanyRegisteredName(e.target.value)}
                            required
                        />
                    </div>

                    {/* Location & City */}
                    <div className="mb-3">
                        <label className="form-label">Location</label>
                        <input
                            type="text"
                            className="form-control"
                            value={companyLocation}
                            onChange={(e) => setCompanyLocation(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">City</label>
                        <input
                            type="text"
                            className="form-control"
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                            required
                        />
                    </div>

                    {/* Admin Name */}
                    <div className="mb-3">
                        <label className="form-label">Admin Name</label>
                        <input
                            type="text"
                            className="form-control"
                            value={companyAdminName}
                            onChange={(e) => setCompanyAdminName(e.target.value)}
                            required
                        />
                    </div>

                    {/* Admin Email */}
                    <div className="mb-3">
                        <label className="form-label">Admin Email</label>
                        <input
                            type="email"
                            className="form-control"
                            value={companyAdminEmail}
                            onChange={(e) => setCompanyAdminEmail(e.target.value)}
                            required
                        />
                    </div>

                    {/* Admin Phone */}
                    <div className="mb-3">
                        <label className="form-label">Admin Phone</label>
                        <input
                            type="text"
                            className="form-control"
                            value={companyAdminPhone}
                            onChange={(e) => setCompanyAdminPhone(e.target.value)}
                        />
                    </div>

                    {/* Registered Status */}
                    <div className="mb-3">
                        <label className="form-label">Registered Status</label>
                        <input
                            type="text"
                            className="form-control"
                            value={companyRegistered}
                            onChange={(e) => setCompanyRegistered(e.target.value)}
                        />
                    </div>

                    {/* Description */}
                    <div className="mb-3">
                        <label className="form-label">Company Description</label>
                        <textarea
                            className="form-control"
                            value={companyDescription}
                            onChange={(e) => setCompanyDescription(e.target.value)}
                            required
                            rows="3"
                        ></textarea>
                    </div>

                    <button type="submit" className="btn btn-primary" disabled={loading}>
                        {loading ? "Adding..." : "Add Company"}
                    </button>
                    <Link to="/company" className="btn btn-secondary ms-2">
                        Cancel
                    </Link>
                </form>
            </div>
        </div>
    );
};

export default AddCompany;
